module.exports = window["nab"]["editor"];